import { ALink } from "@trueskin-web/components"
import { cancelAutorefillIcon } from "@trueskin-web/theme/icons/cancelAutorefillIcon"
import { deliveryIcon } from "@trueskin-web/theme/icons/deliveryIcon"
import { euroIcon } from "@trueskin-web/theme/icons/euroIcon"
import { refillIcon } from "@trueskin-web/theme/icons/refillIcon"
import { Trans } from "@trueskin-web/translations"

const faqs = [
  {
    icon: refillIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.0.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.0.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },
  {
    icon: deliveryIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.1.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.1.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },

  {
    icon: euroIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.2.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.2.answer">
        <span sx={{ fontWeight: "bold" }} />
        <ALink
          isTextColor
          isUnderlined
          href="https://support.formelskin.de/hc/de/articles/360022115719-Gibt-es-eine-Geld-zur%C3%BCck-Garantie-und-wie-funktioniert-sie-
"
          target="_blank"
          rel="noopener noreferrer"
        />
      </Trans>
    ),
  },
  {
    icon: cancelAutorefillIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.3.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.3.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },
]

const antiAgingPlanDetails = {
  preset_formel_only_bimonthly_xl: [
    "Deine medizinische Formel mit effektiven Wirkstoffen, um Deine Haut zu verjüngen.",
    "Unsere Ärzt:innen beraten Dich, ob Deine aktuellen Reinigungs- und Pflegeprodukte dazu passen.",
    "Bekomme alle 2 Monate eine neue Formel ({{totalPrice}} €/2 Monate). Jederzeit ganz einfach kündbar.",
  ],
  preset_sub_bimonthly_xl_w_spf: [
    "Unsere 3-Step-Routine ergänzt um unseren Sonnenschutz mit LSF 50.",
    "Leicht auf der Haut, aber maximaler Schutz gegen Hautalterung.",
    "Bekomme alle 2 Monate ein neues Set ({{totalPrice}} €/2 Monate). Jederzeit ganz einfach kündbar.",
  ],
  preset_sub_bimonthly_xl: [
    "Die ideale 3-Step-Routine für beste Anti-Aging-Ergebnisse.",
    "Ergänzend zu Deiner medizinischen Formel erhältst Du das passende Reinigungsgel und die passende Feuchtigkeitscreme.",
    "Bekomme alle 2 Monate ein neues Set ({{totalPrice}} €/2 Monate). Jederzeit ganz einfach kündbar.",
  ],
  preset_formel_only_sub_one_month: [
    "Deine medizinische Formel mit effektiven Wirkstoffen, um Deine Haut zu verjüngen.",
    "Unsere Ärzt:innen beraten Dich, ob Deine aktuellen Reinigungs- und Pflegeprodukte dazu passen.",
    "Bekomme jeden Monat eine neue Formel.",
  ],
  preset_sub_one_month_w_spf: [
    "Unsere 3-Step-Routine ergänzt um unseren Sonnenschutz mit LSF 50.",
    "Leicht auf der Haut, aber maximaler Schutz gegen Hautalterung.",
    "Bekomme jeden Monat ein neues Set.",
  ],
  preset_sub_one_month: [
    "Die ideale 3-Step-Routine für beste Anti-Aging-Ergebnisse.",
    "Ergänzend zu Deiner medizinischen Formel erhältst Du das passende Reinigungsgel und die passende Feuchtigkeitscreme.",
    "Bekomme jeden Monat in neues Set.",
  ],
}

export { antiAgingPlanDetails, faqs }
